import constantes from '../helpers/constanteHelper'

import Form from 'react-bootstrap/Form'

function FiltrosProdutosBea({ setTipoVisualizacao, especies = [], categorias = [], aplicarFiltros, filtroTema, filtroEspecie, setFiltroEspecie, filtroCategoria, setFiltroCategoria, resolucaoMobile }) {

    return (
        <Form style={{ gap: '20px' }} className=' mb-5 d-flex flex-wrap justify-content-center align-items-center' noValidate id='form-cadastro'>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Tipo de visualização</Form.Label>
                <Form.Select
                    defaultValue={'Por empresa'}
                    onChange={(e) => {
                        setTipoVisualizacao(e.target.value)
                    }}
                >
                    <option key={'Por empresa'} value={'Por empresa'}>Por empresa</option>
                    <option key={'Por espécie'} value={'Por espécie'}>Por espécie</option>
                    <option key={'Por categoria'} value={'Por categoria'}>Por categoria</option>
                </Form.Select>
            </Form.Group>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Filtro por espécie</Form.Label>
                <Form.Select
                    onChange={(e) => {
                        setFiltroEspecie(e.target.value)
                        aplicarFiltros(filtroTema, e.target.value, filtroCategoria)
                    }}
                >
                    <option value={''}></option>
                    {especies.map((especie) => <option key={especie} value={especie}>{especie?.replaceAll(' - Peixes', '')}</option>)}

                </Form.Select>
            </Form.Group>

            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Filtro por categoria</Form.Label>
                <Form.Select
                    onChange={(e) => {
                        setFiltroCategoria(e.target.value)
                        aplicarFiltros(filtroTema, filtroEspecie, e.target.value)
                    }}
                >
                    <option value={''}></option>
                    {categorias.map((categoria) => <option key={categoria} value={categoria}>{categoria}</option>)}

                </Form.Select>
            </Form.Group>
        </Form>
    );
}
export default FiltrosProdutosBea;
